import React from 'react';
import { ISearchSettings } from '../../../models/Settings';
import { Separator, Stack } from '@fluentui/react';
import NumberField from '../../Inputs/NumberField';
import ToggleField from '../../Common/ToggleField';

interface ISearchSettingsFormProps {
    settings: ISearchSettings;
    onChange: (settings: ISearchSettings) => void;
    disabled?: boolean;
}

const SearchSettingsForm: React.FC<ISearchSettingsFormProps> = (props) => {
    // TODO: Add tooltips
    return (<Stack tokens={{ childrenGap: '0' }} style={{ marginTop: '1em' }}>
        {/* <h3>Search Defaults</h3>
        <ToggleField
            inline
            label='Default New Search to In Stock'
            toolTip='If enabled, new searches will start with the "In Stock" checkbox set.'
            checked={props.settings.defaultInStock}
            onChange={(_, checked) => props.onChange({ ...props.settings, defaultInStock: !!checked })}
            disabled={props.disabled}
        />
        <ToggleField
            inline
            label={'Default Match All Keywords'}
            toolTip='If enabled, new searches will start with the "Match All Keywords" checkbox set. This will limit products returned to only those that match all provided keywords rather than allowing partial matches and sorting by relevance.'
            checked={props.settings.defaultMatchAllKeywords}
            onChange={(_, checked) => props.onChange({ ...props.settings, defaultMatchAllKeywords: !!checked })}
            disabled={props.disabled}
        />
        <Separator /> */}
        <h3>Results Display</h3>
        <ToggleField
            inline
            settingId='search.showFacetsInSearchResults'
            label={'Show Facets in Search Results'}
            toolTip='If enabled, a set of facets will be displayed under each product name in the results grid. This can allow you to easily distinguish similar items without clicking into product details.'
            checked={props.settings.showFacetsInSearchResults}
            onChange={(_, checked) => props.onChange({ ...props.settings, showFacetsInSearchResults: !!checked })}
            disabled={props.disabled}
        />
        <NumberField
            settingId='search.numberOfFacets'
            label='Number of Facets in Search Results'
            toolTip='This controls the maximum number of facets that will be shown under the name field.'
            placeholder='9'
            value={props.settings.numberOfFacets}
            onChange={(value) => props.onChange({ ...props.settings, numberOfFacets: value })}
            disabled={props.disabled || !props.settings.showFacetsInSearchResults}
        />
        <Separator />
        <h3>Search Functionality</h3>
        <ToggleField
            inline
            settingId='search.showDesiredQuantity'
            label={'Enable Desired Quantity'}
            toolTip='If enabled, you can specify a desired quantity for products in the search results, and the system will use this information when calculating availability and pricing.'
            checked={props.settings.showDesiredQuantity}
            onChange={(_, checked) => props.onChange({ ...props.settings, showDesiredQuantity: !!checked })}
            disabled={props.disabled}
        />
        <ToggleField
            inline
            settingId='search.enableExpandedSearch'
            label={'Enable Expanded Search'}
            toolTip='Enabling this will allow the system to perform an expanded search using supported integrations when the initial search returns a low number of results.'
            checked={props.settings.enableExpandedSearch}
            onChange={(_, checked) => props.onChange({ ...props.settings, enableExpandedSearch: !!checked })}
            disabled={props.disabled}
        />
        <NumberField
            placeholder='3'
            settingId='search.expandedSearchThreshold'
            label='Expanded Search Threshold'
            toolTip='The minimum number of search results that will trigger an expanded search. If there are this many or fewer results, an expanded search will be triggered with supported integrations.'
            value={props.settings.expandedSearchThreshold}
            onChange={(value) => props.onChange({ ...props.settings, expandedSearchThreshold: value })}
            disabled={props.disabled || !props.settings.enableExpandedSearch}
        />
    </Stack>
    );
};

export default SearchSettingsForm;
